/**
 * @generated SignedSource<<45ee35ba7d590c4c303b7403b970d398>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ForumOwnerKind = "BLOG" | "COMPETITION" | "DATASET" | "EVENT" | "TOP_LEVEL" | "WORKSPACE";
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type TopicPageFragment$data = {
  readonly author: {
    readonly username: string;
    readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
  };
  readonly createdAt: DateTime;
  readonly description: string | null | undefined;
  readonly forum: {
    readonly owner: {
      readonly forumOwnerKind: ForumOwnerKind;
      readonly slug: string;
    };
    readonly slug: string;
  };
  readonly id: string;
  readonly title: string;
  readonly url: string | null | undefined;
  readonly viewerCanDelete: boolean;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"SubjectSubscriptionButtonFragment" | "TopicCommentsFormTopicFragment" | "TopicCommentsFragment" | "TopicDeleteButtonFragment" | "TopicHelmetFragment" | "TopicLinkFragment" | "VoteDisplayFragment">;
  readonly " $fragmentType": "TopicPageFragment";
};
export type TopicPageFragment$key = {
  readonly " $data"?: TopicPageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"TopicPageFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "order"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TopicPageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Forum",
      "kind": "LinkedField",
      "name": "forum",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forumOwnerKind",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "thumbnail",
              "value": true
            }
          ],
          "kind": "FragmentSpread",
          "name": "EntityProfilePicFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": "viewerCanEdit",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_TOPIC"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_TOPIC\")"
    },
    {
      "alias": "viewerCanDelete",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "DELETE_TOPIC"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"DELETE_TOPIC\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TopicCommentsFormTopicFragment"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "order",
          "variableName": "order"
        }
      ],
      "kind": "FragmentSpread",
      "name": "TopicCommentsFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoteDisplayFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubjectSubscriptionButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TopicHelmetFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TopicLinkFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TopicDeleteButtonFragment"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};
})();

(node as any).hash = "169adb70ed4f4eb3fd919248d7ada6e1";

export default node;
